export default function ScrammersNote(): JSX.Element {
  return (
    <p className="scrammers-note">
      SMARD never asks to deposit funds. Beware of scammers acting as our
      representatives.
    </p>
  );
}
